import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  dropAdminTraffic,
  shouldLoadAnalytics,
} from "@/utils/analytics/adminTrafficFilter";

const Analytics = lazy(() =>
  import("@vercel/analytics/react").then((module) => ({
    default: module.Analytics,
  })),
);

const DeferredAnalytics: React.FC = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    // Not locally, and not on admin.wildnetwork.app (WN-245).
    if (!shouldLoadAnalytics(window.location.hostname)) {
      return undefined;
    }

    let timeoutId: number | undefined;
    let idleCallbackId: number | undefined;

    const enable = () => {
      if ("requestIdleCallback" in window) {
        idleCallbackId = window.requestIdleCallback(() => setEnabled(true), {
          timeout: 2000,
        });
        return;
      }

      setEnabled(true);
    };

    const schedule = () => {
      timeoutId = window.setTimeout(enable, 2500);
    };

    if (document.readyState === "complete") {
      schedule();
      return () => {
        if (timeoutId !== undefined) {
          window.clearTimeout(timeoutId);
        }
        if (idleCallbackId !== undefined && "cancelIdleCallback" in window) {
          window.cancelIdleCallback(idleCallbackId);
        }
      };
    }

    window.addEventListener("load", schedule, { once: true });

    return () => {
      window.removeEventListener("load", schedule);
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
      if (idleCallbackId !== undefined && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleCallbackId);
      }
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <Analytics beforeSend={dropAdminTraffic} />
    </Suspense>
  );
};

export default DeferredAnalytics;
